'use client';

/**
 * Web `TurnkeySessionSteward` — binds `@turnkey/react-wallet-kit`'s
 * `useTurnkey()` surface into the platform-neutral steward core
 * (`src/auth/turnkey/use-session-steward.ts`), which owns the rolling
 * session refresh + dead-session reconcile. Mounted inside
 * `TurnkeyModalBridge` (below `WalletKitProvider`, so its renders cannot
 * churn the kit's memoized config/callbacks).
 */
import { c as _c } from "react/compiler-runtime";
import { ClientState, useTurnkey } from '@turnkey/react-wallet-kit';
import { pruneSessionKey } from '../../../../auth/turnkey/prune-session-key.js';
import { useTurnkeySessionSteward } from '../../../../auth/turnkey/use-session-steward.js';
export function TurnkeySessionSteward(t0) {
  const $ = _c(15);
  const {
    onAuthEvent
  } = t0;
  const {
    clientState,
    config,
    getSession,
    refreshSession,
    httpClient
  } = useTurnkey();
  const t1 = clientState === ClientState.Ready;
  let t2;
  if ($[0] !== getSession) {
    t2 = async () => getSession();
    $[0] = getSession;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== refreshSession) {
    t3 = async params => refreshSession(params);
    $[2] = refreshSession;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = config?.auth?.sessionExpirationSeconds;
  let t5;
  if ($[4] !== httpClient) {
    t5 = httpClient === undefined ? undefined : async key => pruneSessionKey(httpClient, key);
    $[4] = httpClient;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = {
      clientReady: t1,
      getSession: t2,
      refreshSession: t3,
      sessionExpirationSeconds: t4,
      pruneSessionKey: t5
    };
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const kit = t6;
  let t7;
  if ($[12] !== kit || $[13] !== onAuthEvent) {
    t7 = {
      kit,
      onAuthEvent
    };
    $[12] = kit;
    $[13] = onAuthEvent;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  useTurnkeySessionSteward(t7);
  return null;
}